/**
 * WeaponSystem — Player auto-fire
 *
 * Handles:
 * - Fire rate timing
 * - Projectile spawning based on current weapon config
 * - Spread patterns
 * - Special weapon types (orbital, homing — deferred for now, logic stubs)
 */

export class WeaponSystem {
  constructor() {
    this._fireTimer = 0;
  }

  update(dt, entities, engine) {
    if (engine.state.gameOver || engine.state.levelUpPending) return;

    const player = entities.queryTag('player')[0];
    if (!player) return;

    const playerPos = entities.getComponent(player, 'position');

    // Auto-fire: always fire when moving or when fire button pressed
    const movement = engine.input.getMovement();
    const isMoving = movement.x !== 0 || movement.y !== 0;
    const shouldFire = isMoving || engine.input.isFiring();

    if (!shouldFire) return;

    this._fireTimer += dt;
    const fireInterval = 1 / engine.playerStats.fireRate;

    if (this._fireTimer >= fireInterval) {
      this._fireTimer = 0;
      this._fire(playerPos, engine.playerStats, entities, engine);
    }
  }

  _fire(playerPos, stats, entities, engine) {
    const count = stats.projectileCount;
    const spreadDeg = stats.projectileSpread;
    const baseAngle = playerPos.angle || 0;

    // Spread pattern centered on facing direction
    const totalSpread = (spreadDeg * Math.PI) / 180;
    const startAngle = baseAngle - totalSpread / 2;
    const step = count > 1 ? totalSpread / (count - 1) : 0;

    for (let i = 0; i < count; i++) {
      const angle = count === 1 ? baseAngle : startAngle + step * i;

      const bulletId = entities.create();

      entities.addComponent(bulletId, 'position', {
        x: playerPos.x + Math.cos(angle) * 15,
        y: playerPos.y + Math.sin(angle) * 15,
        angle: angle,
      });

      entities.addComponent(bulletId, 'velocity', {
        vx: Math.cos(angle) * stats.projectileSpeed,
        vy: Math.sin(angle) * stats.projectileSpeed,
      });

      entities.addComponent(bulletId, 'render', {
        shape: 'circle',
        size: 3,
        color: '#00ff41',
        glow: true,
      });

      entities.addComponent(bulletId, 'damage', {
        amount: stats.damage,
        source: 'player',
      });

      entities.addTag(bulletId, 'bullet');
      entities.addTag(bulletId, 'playerBullet');
    }

    // SFX
    engine.audio.synthSfx('shoot');
  }
}
